import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBzshbr_wc59ibkf2aOxKQFrBcldlWHg2A",
  authDomain: "spocademy-mvp2.firebaseapp.com",
  projectId: "spocademy-mvp2",
  storageBucket: "spocademy-mvp2.firebasestorage.app",
  messagingSenderId: "64377909982",
  appId: "1:64377909982:web:15efed498608abe6dbc84f"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Secondary app instance — used ONLY for admin-side user creation.
// Creating a user on the primary auth instance auto-signs-in that new user,
// which would log the admin out. Using a separate instance keeps the admin
// session on the primary `auth` completely untouched.
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);

export default app;